import { takeEvery } from 'modules/typed-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionDiamondImagesGet } from './actions';

export const sagasDiamondImages = [
  takeEvery([actionDiamondImagesGet.rejected], workerErrorNotifyThunk),
];
